export default __webpack_public_path__ + "static/media/3.f9f1894c.JPG";